import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as yup from 'yup';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../components/Modal/Modal';
import { trans } from '../../../localization';
import NowInput from '../../../components/Common/NowInput';
import NowSelect from '../../../components/Common/NowSelect';
import { setGeneralError } from '../../../layout/components/UniversalModal/actions';
import { createStaff } from '../actions';
import {
  EnumMerchantStaffRoleOrder,
  EnumMerchantStaffStatus,
  genEnumToOption,
} from '../../../constants/enum';
import InputFormWrapper from '../../../components/Common/InputFormWrapper';
import CheckBoxInput from '../../../components/Common/CheckBoxInput';

const initalState = {
  email: '',
  staffRole: {},
  status: true,
  isSubmit: false,
};

class StaffDetailModal extends Component {
  constructor(prop) {
    super(prop);
    this.state = initalState;
    this.staffRoleOptions = genEnumToOption(EnumMerchantStaffRoleOrder);
  }

  componentDidMount() {
    const { itemDetail } = this.props;
    this.onResetState(itemDetail);
  }

  componentDidUpdate(prevProps) {
    const { itemDetail, isOpenDialog } = this.props;
    if (isOpenDialog && isOpenDialog !== prevProps.isOpenDialog) {
      this.onResetState(itemDetail);
    }
  }

  onResetState = (itemDetail) => {
    const {
      email,
      staff_role: staffRoleId,
      status = EnumMerchantStaffStatus.ACTIVE.id,
    } = itemDetail;
    const staffRole = this.staffRoleOptions.find(
      role => role.value === staffRoleId,
    );
    this.setState({
      ...initalState,
      email,
      staffRole: staffRole || {
        value: EnumMerchantStaffRoleOrder.EMPLOYEE.id,
        label: trans(EnumMerchantStaffRoleOrder.EMPLOYEE.label),
      },
      status: status === EnumMerchantStaffStatus.ACTIVE.id,
    });
  };

  handleChangeInput = (stateObj) => {
    this.setState({
      ...stateObj,
    });
  };

  handleCreateUpdate = () => {
    const {
      setGeneralErrorConnect,
      filters,
      createStaffConnect,
      updateStaff,
      itemDetail,
    } = this.props;
    const { restaurant } = filters;
    const { uid } = itemDetail;
    const restaurantId = restaurant.value;
    this.setState({
      isSubmit: true,
    });

    function validate(reqParam, dispatchGeneralError) {
      const requiredMessage = trans('set_staff_required_fill_information');
      const schema = yup.object().shape({
        // email: yup.string().required(requiredMessage),
        staffRole: yup.object().shape({
          value: yup.number().required(),
        }),
        status: yup.boolean().required(requiredMessage),
      });
      try {
        if (restaurantId === 0) {
          dispatchGeneralError(trans('set_staff_choose_restaurant'));
          return false;
        }
        schema.validateSync(reqParam);
        return true;
      } catch (err) {
        dispatchGeneralError(err.message);
        return false;
      }
    }

    function genBody({ state }) {
      const { email, staffRole, status } = state;
      const reqParam = {
        restaurant_id: restaurantId,
        status: status
          ? EnumMerchantStaffStatus.ACTIVE.id
          : EnumMerchantStaffStatus.INACTIVE.id,
        staff_role: staffRole.value,
      };
      if (uid > 0) {
        reqParam.uid = uid;
      } else {
        reqParam.email = email;
      }
      return reqParam;
    }
    if (validate(this.state, setGeneralErrorConnect)) {
      const reqParam = genBody({ state: this.state });
      if (uid > 0) {
        updateStaff(reqParam);
      } else {
        createStaffConnect(reqParam);
      }
    }
  };

  render() {
    const { isOpenDialog, closeDialogGeneric, itemDetail } = this.props;
    const { uid = 0, name } = itemDetail;
    const {
      email, staffRole, status, isSubmit,
    } = this.state;
    const isCreate = uid === 0;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          onRequestClose={() => closeDialogGeneric()}
          width="700px"
        >
          <ModalHeader closeButton>
            {isCreate
              ? trans('set_staff_add_staff')
              : trans('set_staff_edit_staff')}
          </ModalHeader>
          <ModalBody>
            {isCreate ? (
              <InputFormWrapper label={trans('set_staff_email')} required>
                <NowInput
                  value={email}
                  onChange={evt =>
                    this.handleChangeInput({ email: evt.target.value })
                  }
                  required={isSubmit}
                  placeholder={trans('rebranding.set_staff_email_holder')}
                />
              </InputFormWrapper>
            ) : (
              <InputFormWrapper label={trans('set_staff_info')} required>
                <strong>{name}</strong> ({email})
              </InputFormWrapper>
            )}
            <InputFormWrapper
              label={trans('set_staff_edit_staff_role')}
              required
            >
              <NowSelect
                value={staffRole}
                options={this.staffRoleOptions}
                onChange={evt => this.handleChangeInput({ staffRole: evt })}
                isClearable={false}
                required={isSubmit}
              />
            </InputFormWrapper>
            <InputFormWrapper
              label={trans('pos_dish_edit_status')}
              style={{ display: 'inline-flex' }}
            >
              <CheckBoxInput
                value={status}
                onChange={evt =>
                  this.handleChangeInput({ status: evt.target.checked })
                }
              />
            </InputFormWrapper>
          </ModalBody>
          <ModalAction>
            <ModalButton type="cancel" onClick={closeDialogGeneric}>
              {trans('common_close')}
            </ModalButton>
            <ModalButton styleType="red" onClick={() => this.handleCreateUpdate()}>
              {trans('set_staff_save')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createStaffConnect: (dish) => {
    dispatch(createStaff(dish));
  },
  setGeneralErrorConnect: (message) => {
    dispatch(setGeneralError(message));
  },
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps,
  )(StaffDetailModal),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Staff/StaffDetail/StaffDetailModal.jsx